import { render, staticRenderFns } from "./OrgSwitcher.vue?vue&type=template&id=20a30d6e"
import script from "./OrgSwitcher.vue?vue&type=script&lang=js"
export * from "./OrgSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports